import { EurekaZoneInfo } from './eureka';
import { bunnyLabel } from './eureka_translations';
import pagosMap from './pagos.png';

// https://xivapi.com/search?indexes=Fate&filters=ID>=1351,ID<=1369&columns=Description,Name,Url

export const zoneInfoPagos: EurekaZoneInfo = {
  mapImage: pagosMap,
  mapWidth: 1500,
  mapHeight: 950,
  shortName: 'pagos',
  hasTracker: true,
  mapToPixelXScalar: 41.08333,
  mapToPixelXConstant: -85.28333,
  mapToPixelYScalar: 41.09158,
  mapToPixelYConstant: -370.196,
  fairy: {
    en: 'Pagos Elemental',
    de: 'Pagos-Elementar',
    fr: 'Élémentaire Pagos',
    ja: 'パゴス・エレメンタル',
    cn: '恒冰元灵',
    ko: '파고스 정령',
    tc: '恆冰元靈',
  },
  nms: {
    northbunny: {
      label: bunnyLabel,
      x: 20.5,
      y: 21.5,
      fateId: 1368,
      bunny: true,
      respawnMinutes: 8,
    },
    southbunny: {
      label: bunnyLabel,
      x: 18.0,
      y: 27.5,
      fateId: 1367,
      bunny: true,
      respawnMinutes: 8,
    },
    snowqueen: {
      label: {
        en: 'Queen',
        de: 'Schneekönigin',
        fr: 'Reine',
        ja: '女王',
        cn: '周冬雨',
        ko: '눈의 여왕',
        tc: '周冬雨',
      },
      trackerName: {
        en: 'Queen',
        de: 'Königin',
        fr: 'Reine',
        ja: '女王',
        cn: '周冬雨',
        ko: '눈 여왕',
        tc: '周冬雨',
      },
      x: 21.5,
      y: 26.5,
      fateId: 1351,
    },
    taxim: {
      label: {
        en: 'Taxim',
        de: 'Taxim',
        fr: 'Taxim',
        ja: 'タキシム',
        cn: '读书人',
        ko: '텍심',
        tc: '讀書人',
      },
      trackerName: {
        en: 'Taxim',
        de: 'Taxim',
        fr: 'Taxim',
        ja: 'タキシム',
        cn: '读书人',
        ko: '텍심',
        tc: '讀書人',
      },
      x: 25.5,
      y: 28.3,
      fateId: 1369,
      time: 'Night',
    },
    ashdragon: {
      label: {
        en: 'Dragon',
        de: 'Aschedrache',
        fr: 'Dragon',
        ja: 'ドラゴン',
        cn: '灰烬龙',
        ko: '용',
        tc: '灰燼龍',
      },
      trackerName: {
        en: 'Dragon',
        de: 'Drache',
        fr: 'Dragon',
        ja: 'アッシュ',
        cn: '灰烬龙',
        ko: '잿더미 용',
        tc: '灰燼龍',
      },
      x: 29.7,
      y: 30.0,
      fateId: 1353,
    },
    glavoid: {
      label: {
        en: 'Glavoid',
        de: 'Glavoid',
        fr: 'Graboïde',
        ja: 'グラヴォイド',
        cn: '魔虫',
        ko: '지렁이',
        tc: '魔蟲',
      },
      trackerName: {
        en: 'Glavoid',
        de: 'Glavoid',
        fr: 'Graboïde',
        ja: 'グラヴォ',
        cn: '魔虫',
        ko: '그라보이드',
        tc: '魔蟲',
      },
      x: 33.0,
      y: 28.0,
      fateId: 1354,
    },
    anapos: {
      label: {
        en: 'Anapos',
        de: 'Anapo',
        fr: 'Anapos',
        ja: 'アナポ',
        cn: '安娜波',
        ko: '아나포',
        tc: '安娜波',
      },
      trackerName: {
        en: 'Anapos',
        de: 'Anapos',
        fr: 'Anapos',
        ja: 'アナポ',
        cn: '安娜波',
        ko: '아나포',
        tc: '安娜波',
      },
      x: 33.0,
      y: 21.5,
      fateId: 1355,
      weather: 'Fog',
    },
    hakutaku: {
      label: {
        en: 'Haku',
        de: 'Hakutaku',
        fr: 'Haku',
        ja: 'ハクタク',
        cn: '白泽',
        ko: '백택',
        tc: '白澤',
      },
      trackerName: {
        en: 'Haku',
        de: 'Haku',
        fr: 'Haku',
        ja: 'ハクタク',
        cn: '白泽',
        ko: '백택',
        tc: '白澤',
      },
      x: 29.0,
      y: 22.5,
      fateId: 1366,
    },
    igloo: {
      label: {
        en: 'Igloo',
        de: 'Iglu',
        fr: 'Igloo',
        ja: 'イグル',
        cn: '雪屋王',
        ko: '이글루',
        tc: '雪屋王',
      },
      trackerName: {
        en: 'Igloo',
        de: 'Iglu',
        fr: 'Igloo',
        ja: 'イグルー',
        cn: '雪屋王',
        ko: '이글루',
        tc: '雪屋王',
      },
      x: 17,
      y: 16,
      fateId: 1357,
    },
    asag: {
      label: {
        en: 'Asag',
        de: 'Asag',
        fr: 'Asag',
        ja: 'アサグ',
        cn: '阿萨格',
        ko: '아사그',
        tc: '阿薩格',
      },
      trackerName: {
        en: 'Asag',
        de: 'Asag',
        fr: 'Asag',
        ja: 'アサグ',
        cn: '阿萨格',
        ko: '아사그',
        tc: '阿薩格',
      },
      x: 11.3,
      y: 10.5,
      fateId: 1356,
    },
    surabhi: {
      label: {
        en: 'Surabhi',
        de: 'Surabhi',
        fr: 'Surabhi',
        ja: 'スラビー',
        cn: '山羊',
        ko: '염소',
        tc: '山羊',
      },
      trackerName: {
        en: 'Surabhi',
        de: 'Surabhi',
        fr: 'Surabhi',
        ja: 'スラビー',
        cn: '山羊',
        ko: '수라비',
        tc: '山羊',
      },
      x: 10.5,
      y: 20.5,
      fateId: 1352,
    },
    kingarthro: {
      label: {
        en: 'Arthro',
        de: 'König Athro',
        fr: 'Arthro',
        ja: 'アースロ',
        cn: '螃蟹',
        ko: '게',
        tc: '螃蟹',
      },
      trackerName: {
        en: 'Arthro',
        de: 'Athro',
        fr: 'Arthro',
        ja: 'アスロ',
        cn: '螃蟹',
        ko: '아스로',
        tc: '螃蟹',
      },
      x: 8.0,
      y: 15.2,
      fateId: 1360,
      weather: 'Fog',
    },
    minotaurs: {
      label: {
        en: 'Minotaurs',
        de: 'Minotauren',
        fr: 'Minotaures',
        ja: 'ミノタウロス',
        cn: '双牛',
        ko: '미노타우루스',
        tc: '雙牛',
      },
      trackerName: {
        en: 'Brothers',
        de: 'Brüder',
        fr: 'Frères',
        ja: 'ミノ',
        cn: '双牛',
        ko: '형제',
        tc: '雙牛',
      },
      x: 13.8,
      y: 18.4,
      fateId: 1358,
    },
    holycow: {
      label: {
        en: 'Holy Cow',
        de: 'Heilsbringer',
        fr: 'Vache sacrée',
        ja: '聖牛',
        cn: '圣牛',
        ko: '소',
        tc: '聖牛',
      },
      trackerName: {
        en: 'Holy Cow',
        de: 'Heil',
        fr: 'Vache',
        ja: '聖牛',
        cn: '圣牛',
        ko: '신성 소',
        tc: '聖牛',
      },
      x: 26,
      y: 16,
      fateId: 1361,
    },
    hadhayosh: {
      label: {
        en: 'Hadha',
        de: 'Hadhayosh',
        fr: 'Hadha',
        ja: 'ハダヨッシュ',
        cn: '贝爷',
        ko: '하다요쉬',
        tc: '貝爺',
      },
      trackerName: {
        en: 'Behe',
        de: 'Hadhayosh',
        fr: 'Hadha',
        ja: 'ハダヨ',
        cn: '贝爷',
        ko: '하다요쉬',
        tc: '貝爺',
      },
      x: 30,
      y: 19,
      fateId: 1362,
      weather: 'Thunder',
    },
    horus: {
      label: {
        en: 'Horus',
        de: 'Horus',
        fr: 'Horus',
        ja: 'ホルス',
        cn: '荷鲁斯',
        ko: '호루스',
        tc: '荷魯斯',
      },
      trackerName: {
        en: 'Horus',
        de: 'Horus',
        fr: 'Horus',
        ja: 'ホルス',
        cn: '荷鲁斯',
        ko: '호루스',
        tc: '荷魯斯',
      },
      x: 26,
      y: 20,
      fateId: 1359,
      weather: 'Heat Waves',
    },
    mainyu: {
      label: {
        en: 'Mainyu',
        de: 'Mainyu',
        fr: 'Mainyu',
        ja: 'マンユ',
        cn: '大眼',
        ko: '마이뉴',
        tc: '大眼',
      },
      trackerName: {
        en: 'Mainyu',
        de: 'Mainyu',
        fr: 'Mainyu',
        ja: 'マンユ',
        cn: '大眼',
        ko: '마이뉴',
        tc: '大眼',
      },
      x: 25,
      y: 24,
      fateId: 1363,
    },
    cassie: {
      label: {
        en: 'Cassie',
        de: 'Cassie',
        fr: 'Cassie',
        ja: 'キャシ',
        cn: '凯西',
        ko: '캐시',
        tc: '凱西',
      },
      trackerName: {
        en: 'Cassie',
        de: 'Cassie',
        fr: 'Cassie',
        ja: 'キャシー',
        cn: '凯西',
        ko: '캐시',
        tc: '凱西',
      },
      weather: 'Blizzards',
      x: 22,
      y: 14,
      fateId: 1365,
    },
    louhi: {
      label: {
        en: 'Louhi',
        de: 'Louhi',
        fr: 'Louhi',
        ja: 'ロウヒ',
        cn: '娄希',
        ko: '로우히',
        tc: '婁希',
      },
      trackerName: {
        en: 'Louhi',
        de: 'Louhi',
        fr: 'Louhi',
        ja: 'ロウヒ',
        cn: '娄希',
        ko: '로우히',
        tc: '婁希',
      },
      x: 36,
      y: 18.5,
      fateId: 1364,
      time: 'Night',
    },
  },
};
